import { Router } from '@reach/router';
import { PageProps } from 'gatsby';
import {
  useOnboardingRedirects,
  useSettingsSubscription,
} from 'modules/settings';
import React from 'react';
import { PageLoading } from 'shared/components';
import { Onboarding } from '../modules/onboarding/components';

const OnboardingPage: React.FC<PageProps> = (props) => {
  useSettingsSubscription();
  const isLoading = useOnboardingRedirects();

  return (
    <PageLoading isLoading={isLoading}>
      <Router basepath="/onboarding">
        <Onboarding {...props} path="/" />
      </Router>
    </PageLoading>
  );
};

export default OnboardingPage;
